import { createSlice } from "redux-starter-kit";
import QueryString from "query-string";
import { merge, objectValuesToArrays } from "../../lib/utils";
import { getCookie } from "react-use-cookie";
import menuFilters from "redux/slices/data/menuFilters.json";
import { getQueryString } from "./filterUrlMaker";
import { auditLocationChange } from "lib/analytics/auditEvents";

const initialState = { filter: {}, pageFrom: {} };

export const filterReducer = createSlice({
  name: "filter", //todo ren -> query
  initialState: initialState,
  reducers: {
    setSort: (state, action) => {
      state.sort = action.payload;
    },
    setFilter: (state, action) => {
      state.filter = filterFromPath(action.payload); // testing only
    },
  },
  extraReducers: {
    "@@router/LOCATION_CHANGE": (state, action) => {
      state.qs = QueryString.parse(action.payload.location.search);
      state.path = action.payload.location.pathname;
      state.pageFrom = pageFromQS(state.qs);
      state.qsFilter = filterFromQS(state.qs);
      state.pathFilter = filterFromPath(state.path);
      state.filter = merge(state.qsFilter, state.pathFilter);
      state.sort = getQueryString().sort || getCookie("grp-sort");
      auditLocationChange(state, action);
    },
  },
});

const pageFromQS = (qs) => (qs.From ? { From: qs.From } : {});

export const filterFromQS = (qs) => {
  let filter = objectValuesToArrays(qs);
  delete filter.SortAsc;
  delete filter.SortDesc;
  delete filter.From;
  return filter;
};

const filterFromPath = (path) => {
  if (!path.includes("/latest-research")) return {};
  const [, , assetClass, region, product, subProduct] = decodeURI(path).split("/");
  let filter = {
    ...menuFilters[assetClass],
    ...menuFilters[region],
    ...menuFilters[product],
    ...menuFilters[subProduct],
  };
  return objectValuesToArrays(filter);
};
